import { render, staticRenderFns } from "./AdvertiserEdit.vue?vue&type=template&id=e4c61c94"
import script from "./AdvertiserEdit.vue?vue&type=script&lang=js"
export * from "./AdvertiserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports